import { NumericFormat } from 'react-number-format';
import { useSettings } from 'context/SettingsContext';
import { forwardRef, useEffect, useState } from 'react';
import {
  getBaseCurrencyPrefix,
  getIsLocalCurrencyMode,
  getLocalCurrencyPrefix,
} from 'utils/helpers/currency/currencyHelpers';

interface Props {
  value: number;
  onValueChange?: (values: any) => void;
  required?: boolean;
  allowNegative?: boolean;
  disabled?: boolean;
} 

const InputPriceRate = forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      onValueChange,
      required = false,
      allowNegative = true,
      disabled = false,
    },
    ref
  ) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isLocalMode = getIsLocalCurrencyMode(rate);
    const localPrefix = getLocalCurrencyPrefix();
    const basePrefix = getBaseCurrencyPrefix();

    const [valueLocal, setValueLocal] = useState(value * rate);

    useEffect(() => {
      if (!isLocalMode) {
        setValueLocal(value * rate);
      }
    }, [value, rate, isLocalMode]);

    return (
      <div className="d-flex">
        <NumericFormat
          disabled={disabled}
          allowNegative={allowNegative}
          className="form-control object-price"
          style={{
            borderRadius: isLocalMode
              ? 'var(--bs-border-radius)'
              : 'var(--bs-border-radius) 0px 0px var(--bs-border-radius)',
          }}
          prefix={isLocalMode ? localPrefix : basePrefix}
          thousandSeparator=","
          decimalScale={2}
          allowLeadingZeros
          value={value}
          required={required}
          onValueChange={onValueChange}
          getInputRef={(el) => {
            if (!ref) return;
            if (typeof ref === 'function') {
              ref(el);
            } else {
              ref.current = el;
            }
          }}
        />

        {!isLocalMode && (
        <NumericFormat
          className="form-control object-price disable"
          style={{
            borderRadius: '0px var(--bs-border-radius) var(--bs-border-radius) 0px',
            borderLeft: 'none',
          }}
          prefix={localPrefix}
          disabled
          value={valueLocal.toFixed(2)}
          thousandSeparator=","
          decimalScale={2}
          allowLeadingZeros
        />
        )}
      </div>
    );
  }
);

export default InputPriceRate;
